import { render, staticRenderFns } from "./share.vue?vue&type=template&id=61c4caeb&scoped=true&"
import script from "./share.js?vue&type=script&lang=js&"
export * from "./share.js?vue&type=script&lang=js&"
import style0 from "./share.css?vue&type=style&index=0&id=61c4caeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4caeb",
  null
  
)

export default component.exports